import { SvgIcon, Typography, Box } from "@mui/material";
import { FactCheckOutlined as FactCheckOutlinedIcon } from "@mui/icons-material";

const MessageSuccess = ({ messageSuccess }) => {
  return (
    <Box
      sx={{
        backgroundColor: "success.light",
        p: 4,
        borderRadius: 2,
        display: "flex",
        alignItems: "center",
      }}
    >
      <SvgIcon sx={{ color: "success.strong", fontSize: 55, mr: 2 }}>
        <FactCheckOutlinedIcon />
      </SvgIcon>

      <Box>
        <Typography
          sx={{
            color: "dark.neutralBlack",
            fontSize: 16,
            fontWeight: 700,
            fontFamily: "Inter",
          }}
        >
          {messageSuccess}
        </Typography>
      </Box>
    </Box>
  );
};

export default MessageSuccess;
